import { Tooltip } from '@mui/material';
import { IValidationConfig } from '../../../types/my-types';
import EmergencyIcon from '@mui/icons-material/Emergency';
import CalculateIcon from '@mui/icons-material/Calculate';

import {
  isFieldRequired,
  fieldHasCurrentChargesSumCheck,
  getExistingSumcheckConfig,
  isCustomSumcheckConfig,
} from '../../../utils/fieldValidations';

interface IFieldValidationIconsProps {
  validationConfig: IValidationConfig[] | [] | null | undefined;
  hasFixedWidth: boolean;
  fieldLabel: string;
}

const FieldValidationIcons = ({
  validationConfig,
  hasFixedWidth = true,
  fieldLabel,
}: IFieldValidationIconsProps) => {
  const isCurrentlyRequired = isFieldRequired(validationConfig ?? null);
  const isCurrentChargesSumCheck = fieldHasCurrentChargesSumCheck(validationConfig ?? null);
  const existingSumcheckConfig = getExistingSumcheckConfig(validationConfig ?? null);
  const hasCustomConfig = isCustomSumcheckConfig(existingSumcheckConfig);

  return (
    <div
      style={{
        ...(hasFixedWidth ? { minWidth: '30px' } : {}),
        display: 'flex',
        alignItems: 'center',
      }}
    >
      {isCurrentlyRequired ? (
        <div style={{ minWidth: '15px', display: 'flex', alignItems: 'center' }}>
          <Tooltip title={'Required'} placement="top">
            <EmergencyIcon
              data-cy={`icon-field-validation-required-${fieldLabel}`}
              style={{ color: 'red', fontSize: '13px' }}
            />
          </Tooltip>
        </div>
      ) : null}
      {isCurrentChargesSumCheck ? (
        <div style={{ minWidth: '15px', display: 'flex', alignItems: 'center' }}>
          <Tooltip
            title={hasCustomConfig ? 'Charges Sumcheck (Custom)' : 'Charges Sumcheck'}
            placement="top"
          >
            <CalculateIcon
              data-cy={`icon-field-validation-sumcheck-${fieldLabel}`}
              style={{
                fontSize: '13px',
                color: hasCustomConfig ? '#1976d2' : 'inherit',
              }}
            />
          </Tooltip>
          {hasCustomConfig && (
            <span
              style={{
                fontSize: '10px',
                color: '#1976d2',
                fontWeight: 'bold',
                marginLeft: '-3px',
                lineHeight: 1,
              }}
              data-cy={`icon-field-validation-sumcheck-custom-${fieldLabel}`}
            >
              *
            </span>
          )}
        </div>
      ) : null}
    </div>
  );
};

export default FieldValidationIcons;
